module.exports = __webpack_public_path__ + "static/media/au-nt.dbcec227.svg";